import { createContext } from "react";

const context = createContext({
  searchText: "",
  selectedItems: {},
  handleSetSelectedItems: () => {},
  handleClearSelectedItems: () => {},
  notificationList: [],
  setNotificationList: () => {},
  page: 1,
  totalItems: 0,
  handleChangePage: () => {},
  handleSearchChange: () => {},
  handleCategoryChange: () => {},
  renderContents: () => {},
  order: "desc",
  orderBy: "",
  handleRequestSort: () => {},
  actionsList: [],
  loading: false,
  anchorEl: null,
  handleCloseActions: () => {},
});

export default context;
